import { render, staticRenderFns } from "./ResourceSelector.vue?vue&type=template&id=2e4fab62"
import script from "./ResourceSelector.vue?vue&type=script&lang=js"
export * from "./ResourceSelector.vue?vue&type=script&lang=js"
import style0 from "./ResourceSelector.vue?vue&type=style&index=0&id=2e4fab62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports